import { AutogenModelBrokerageWorkflowDetail, AutogenRowBrokerageWorkflowDetail } from "./autogen/AutogenModelBrokerageWorkflowDetail";

export class ModelBrokerageWorkflowDetail extends AutogenModelBrokerageWorkflowDetail<RowBrokerageWorkflowDetail> {
	constructor() {
		super(RowBrokerageWorkflowDetail);
	}
}

export class RowBrokerageWorkflowDetail extends AutogenRowBrokerageWorkflowDetail {
}